module.exports = __webpack_public_path__ + "media/Video 95.559e8db0.mp4";